import {populateCommentCommentContainer} from "./populateCommentCommentContainer";
export function getCommentCommentContainerCodeHtml(comment, datetime, parentCommentId, position, commentId, communityUser, sumProsts, sumComments, textChanged) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=get_comment_comment_container_code_html",
        datatype: "json",
        data: {
            "ajax_call_comment": comment,
            "ajax_call_datetime": datetime,
            "ajax_call_comment_id": commentId,
            "ajax_call_nickname": communityUser.nickname,
            "ajax_call_site": siteCode,
            "ajax_call_language": mainLanguageCode,
            "ajax_call_text_changed": textChanged,
            "ajax_call_nickname_slug": communityUser.nickname_slug
        },
        success: function (output) {
            populateCommentCommentContainer(parentCommentId, output, position);
            var commentContainer = $(".display_comment_comment#comment_comment_" + commentId);
            commentContainer.find(".prost_count_comment_comment").text(sumProsts);
            // commentContainer.find(".comment_count_comment_comment").text(sumComments);
            commentContainer.find(".comment_count_comment_comment").hide();

            var image = "/layout/frontend/stiegl/dist/images/no-profile-pic.png";
            if (communityUser.image !== null) {
                image = "/userdata/stammtisch/profile_images/resized/" + communityUser.image;
            }
            commentContainer.find(".profile_image").find("img").attr("src", image);
        }
    });
}